import React from 'react';
import { components } from 'react-select';

export const NoOptionsMessage = props => (
  <div>
    <components.NoOptionsMessage {...props} />
  </div>
);
